import {
  enumElementBorderStyle,
  enumFillMode,
  enumXMLType,
  kRoundRectRadius,
  kSmallIcon
} from "../constants";
import { QBoxOverlay_AppIcon } from "./QBoxOverlay_AppIcon";
import { SVG_DrawImage } from "../utils/SVG_DrawImage";
import { XML_Scale } from "../utils/XML_Scale";
import { XML_ScaleAndShiftX } from "../utils/XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "../utils/XML_ScaleAndShiftY";
import { XML_GetScale } from "../utils/XML_GetScale";
import { XML_DrawPlanIconPDF } from "../utils/XML_DrawPlanIconPDF";
import { SVG_DrawDisabledChartBox } from "../utils/SVG_DrawDisabledChartBox";
import { XML_RenderChartBoxPDF } from "../utils/XML_RenderChartBoxPDF";

export class QBoxOverlay_Delete extends QBoxOverlay_AppIcon {
  constructor() {
    super();
    this.overlayType = "delete";
    this.fFillColor = "#FF0000";
    this.fBorderColor = "#AA0000";
    this.fBoxFill = "#777777";
  }

  DoAltRender(altCanvas) {
    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();

    var x = this.GetPositionX();
    var y = this.GetPositionY();
    var width = this.fChartBox.GetWidth();
    if (this.fOverrideWidth !== null) {
      width = this.fOverrideWidth;
    }
    var layer = this.GetLayer();
    var scale = XML_GetScale(altCanvasElement, layer); // drawElement["scale"];
    if (scale != null) width *= scale;
    switch (altCanvasType) {
      case "SVG":
        SVG_DrawDisabledChartBox(this.fChartBox, altCanvasElement);
        SVG_DrawImage(
          this.fHorzOffset + this.fDeltaDefX,
          this.fVertOffset + this.fDeltaDefY,
          24,
          24,
          null,
          null,
          null,
          this.fEnabledImage,
          layer,
          altCanvasElement
        );
        break;
      case "XML":
        var docType = altCanvasElement.GetDocType();
        var lineLen = Math.floor(width / 8) * 2;

        var chartBox = this.fChartBox;
        if (docType === enumXMLType.PDF) {
          var lineLen = Math.floor(width / 8);
          var x0 = XML_ScaleAndShiftX(x, altCanvasElement, layer);
          var y0 = XML_ScaleAndShiftY(y, altCanvasElement, layer);
          y0 = altCanvasElement.ConvertY(y0);
          var r = chartBox.GetAdjBounds(kRoundRectRadius);
          var r1 = chartBox.GetOuterBorder(r, kRoundRectRadius);
          if (chartBox.GetDataObj())
            XML_RenderChartBoxPDF(
              r,
              r1,
              chartBox.GetBoxShapeType(),
              enumFillMode.solidFill,
              this.fBoxFill,
              enumElementBorderStyle.noBorder,
              0,
              false,
              false,
              false,
              altCanvasElement,
              layer,
              false,
              0.2
            );
          var iconBase = this.fIconSize ?? kSmallIcon.imageWidth;
          var scaledIconSize = Math.round(XML_Scale(iconBase, altCanvasElement, layer));
          XML_DrawPlanIconPDF(
            x0,
            y0,
            scaledIconSize,
            scaledIconSize,
            lineLen,
            this.fBoxFill,
            this.fFillColor,
            this.getExportIconType(),
            layer,
            altCanvasElement
          );
        } else {
          if (!chartBox.GetDataObj()) {
            y += 4;
            x += 2;
          }

          var coords = this.getPPTCoordinates(x, y, altCanvasElement, layer);
          x0 = coords.x0;
          y0 = coords.y0;
          y0 = altCanvasElement.ConvertY(y0);
          this.drawPPTIcon(x0, y0, altCanvasElement, layer);
        }
        break;
    }
  }
}
